import { render, staticRenderFns } from "./themeWetland.vue?vue&type=template&id=2b1f0bfb&scoped=true&"
import script from "./themeWetland.vue?vue&type=script&lang=js&"
export * from "./themeWetland.vue?vue&type=script&lang=js&"
import style0 from "./themeWetland.vue?vue&type=style&index=0&id=2b1f0bfb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f0bfb",
  null
  
)

export default component.exports